<template>
    <div class="cs-offerWallItem" v-if="offerWallItemInfo && countdown">
      <div class="cs-offerWallItemHeader" :class="[isFutureOffer()? 'cs-offerWallItemHeader--future' : '']">
        {{getOfferHeader()}}
      </div>
      <div class="cs-offerWallItemBody" :class="[isFutureOffer()? 'cs-offerWallItemBody--future' : '']">
        <div class="cs-offerWallItemQuantity">{{ offerWallItemInfo.serviceQuantity }}</div>
        <div class="cs-offerWallItemName" :class="{'cs-scrollingText': isTextLongerThan(offerWallItemInfo.serviceName,20), 'cs-offerWallItemName--scrolling': isTextLongerThan(offerWallItemInfo.serviceName,20) }">{{ offerWallItemInfo.serviceName }}</div>
        <div class="cs-offerWallItemDiscount">-{{ offerWallItemInfo.discountPercentage }}%</div>
        <div class="cs-offerWallItemPrice" :class="[isFutureOffer()? 'cs-offerWallItemPrice--future' : '']">{{ Number.parseFloat(offerWallItemInfo.discountedPrice.replace(',','.')).toFixed(2)}}€</div>
        <div class="cs-offerWallItemCTA" :class="[isFutureOffer()? 'cs-offerWallItemCTA--future' : '']" v-on:click="openModal()" v-html="getCTAhtml()">
        </div>
      </div>

      <UserProfileComponent v-if="showUserComponent()" :offer="offerWallItemInfo" :dictionary="dictionary.defaultPurchaseDictionary" @closeComponent="togglePurchaseModal()"></UserProfileComponent>
      <UserContentComponent v-if="showUserContentComponent()" :offer="offerWallItemInfo" :dictionary="dictionary.defaultPurchaseDictionary" @closeComponent="togglePurchaseModal()"></UserContentComponent>
      <DefaultComponent v-if="showDefaultComponent()"  :offer="offerWallItemInfo" :dictionary="dictionary.defaultPurchaseDictionary" :isDefaultService="true" @closeComponent="togglePurchaseModal()"></DefaultComponent>
      <NotifyMeComponent v-if="isNotifyMeModalOpen" :offer="offerWallItemInfo" :dictionary="dictionary.notify" @close-notify-me="toggleNotifyMeModal()"></NotifyMeComponent>
    </div>

  </template>
  
  <script>
  import UserContentComponent from './UserContentComponent.vue';
  import DefaultComponent from './DefaultComponent.vue';
  import UserProfileComponent from './UserProfileComponent.vue';
  import { SERVICE_TYPE } from '@/assets/js/constants';
  import { isTextLongerThan } from '@/assets/js/formatUtils';
  import NotifyMeComponent from './NotifyMeComponent.vue';
  export default {
    name: 'OfferWallItemComponent',
    props: ["offerWallItemInfo", "dictionary","shouldOpenModal"],
    data: function(){
      return {
        isPurchaseModalOpen: false,
        isNotifyMeModalOpen: false,
        countdown: null,
      }
    },
    components: {
    UserContentComponent,
    DefaultComponent,
    NotifyMeComponent,
    UserProfileComponent
  },
    methods: {
      isTextLongerThan: isTextLongerThan,
      showUserComponent: function(){
        return ( this.offerWallItemInfo.sliderID == SERVICE_TYPE.igUser || this.offerWallItemInfo.sliderID == SERVICE_TYPE.tkUser ) && this.isPurchaseModalOpen;
      },
      showUserContentComponent: function(){
        return ( this.offerWallItemInfo.sliderID == SERVICE_TYPE.igPhoto || 
        this.offerWallItemInfo.sliderID == SERVICE_TYPE.igVideo || 
        this.offerWallItemInfo.sliderID == SERVICE_TYPE.tkVideo ) && this.isPurchaseModalOpen;
      },
      showDefaultComponent: function(){
        return this.offerWallItemInfo.sliderID == SERVICE_TYPE.default && this.isPurchaseModalOpen;
      },
      togglePurchaseModal: function(){
        this.isPurchaseModalOpen = !this.isPurchaseModalOpen;
      },
      toggleNotifyMeModal(){
        this.isNotifyMeModalOpen = !this.isNotifyMeModalOpen;
      },
      getTimeOfferEndsIn: function(){
        var date = new Date(this.offerWallItemInfo.offerEndDate.replace(/-/g, "/") + " " + this.offerWallItemInfo.offerEndTime);
        var now = new Date();
        var diff = date.getTime() - now.getTime();
        if(diff < 0){
          this.$emit("offerEnded", this.offerWallItemInfo);
        }else {
          var hours = Math.floor(diff / 1000 / 60 / 60);
          var minutes = Math.floor(diff / 1000 / 60) - (hours * 60);
          var seconds = Math.floor(diff / 1000) - (hours * 60 * 60) - (minutes * 60);
          this.countdown =  Math.abs(hours).toLocaleString('it-IT',{ minimumIntegerDigits: 2 }) + ":" + minutes.toLocaleString('it-IT',{ minimumIntegerDigits: 2 }) + ":" + seconds.toLocaleString('it-IT',{ minimumIntegerDigits: 2 });
        }
        },
      getTimeOfferStartsIn: function(){
        var date = new Date(this.offerWallItemInfo.offerStartDate.replace(/-/g, "/") + " " + this.offerWallItemInfo.offerStartTime);
        var now = new Date();
        var diff = date.getTime() - now.getTime();
        if(diff < 0){
          this.$emit("offerStarted", this.offerWallItemInfo);
        }{
          var hours = Math.floor(diff / 1000 / 60 / 60);
          var minutes = Math.floor(diff / 1000 / 60) - (hours * 60);
          var seconds = Math.floor(diff / 1000) - (hours * 60 * 60) - (minutes * 60);
          this.countdown =  Math.abs(hours).toLocaleString('it-IT',{ minimumIntegerDigits: 2 }) + ":" + minutes.toLocaleString('it-IT',{ minimumIntegerDigits: 2 }) + ":" + seconds.toLocaleString('it-IT',{ minimumIntegerDigits: 2 });
        }
      },
      getDateTime: function(date, time){
          const dateParts = date.split('-');
          const timeParts = time.split(':');
          return new Date(dateParts[0], dateParts[1] - 1, dateParts[2], timeParts[0], timeParts[1]);
      },
      startCounter: function(){
        setInterval(() => {
          if(this.offerWallItemInfo.status == "active"){
            this.getTimeOfferEndsIn();
          } else if (this.offerWallItemInfo.status == "future"){
            this.getTimeOfferStartsIn();
          }
        }, 1000);
      },
      isFutureOffer: function(){
        return this.offerWallItemInfo.status == "future";
      },
      getOfferHeader: function(){
        if(this.offerWallItemInfo.status == "active"){
          return this.dictionary.endsIn + this.countdown;
        } else if(this.offerWallItemInfo.status == "future" ){
          return this.dictionary.startsIn + this.countdown;
        }
      },
      getCTAhtml(){
        if(this.offerWallItemInfo.status == "active"){
          return this.dictionary.buyNow;
        } else if(this.offerWallItemInfo.status == "future" ){
          return `
          <img src="https://comprasocial.me/wp-content/uploads/2022/11/envelope.svg">
          ${this.dictionary.notifyMe}
          <img src="https://comprasocial.me/wp-content/uploads/2022/11/bell.svg">
          `;
        }
      },
      openModal(){
        if(this.offerWallItemInfo.status == "active"){
          this.togglePurchaseModal();
        } else if(this.offerWallItemInfo.status == "future" ){
          this.toggleNotifyMeModal();
        }
      },
      checkIfHasToOpenModal(){
        if(this.shouldOpenModal){
          this.openModal();
        }
      }
    },
    mounted: function(){
      this.startCounter();
      this.checkIfHasToOpenModal();
    },
  }
  </script>
  
  <style lang="scss" scoped>
  @import "@/assets/scss/animations.scss";
    .cs-userProfileComponent, .cs-userContentComponent, .cs-defaultComponent, .cs-notifyMeComponent{
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 10, 102, 0.58);;
      z-index: 10;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    @media screen and (min-width: 768px) {
      .cs-userProfileComponent, .cs-userContentComponent, .cs-defaultComponent, .cs-notifyMeComponent{
        left: 170px;
      }
    }

    .cs-offerWallItem {
      width: 170px;
      height: 190px;
      background-color: #fff;
      margin: 10px;
      border-radius: 25px;

      @media screen and (min-width: 768px) {
        width: 190px;
        height: 190px;
      }
      &Header{
        font-size: 14px;
        font-weight: 400;
        background: #8F62EF;
        border-radius: 25px 25px 0px 0px;
        height: 30px;
        margin-top: -2px;
        display: flex;
        color: white;
        align-items: center;
        justify-content: center;

        &--future{
          background: #FFCA3C;
          color: #000;
        }
      }

      &Body{
        text-align: center;
        color: #8F62EF;
        overflow: hidden;
        &--future{
          color: #223B5F;
        }
      }

      &Quantity{
        font-size: 20px;
        font-weight: 700;
      }

      &Name{
        font-size: 15px;
        font-weight: 700;
        white-space: nowrap;
        &--scrolling {
          margin-left: 20px;
          width: fit-content;
        }
      }

      &Discount{
        color: #00DAD2;
        font-size: 30px;
        font-weight: 700;
      }

      &Price{
        color: #61CE70;
        font-size: 15px;
        font-weight: 700;

        &--future {
          color: #223B5F;
        }
      }

      &CTA{
        background: #61CE70;
        border-radius: 25px;
        border: 3px solid #51F267;
        color: white;
        height: 30px;
        text-align: center;
        cursor: pointer;
        margin: 0 10px 10px;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        font-size: 14px;

        &--future{
          background: #223B5F;
          border: 3px solid #0194F4;
          color: #fff;
        }
      }

      
    }
  </style>
  